var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUprightarr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.456023 8.3536C0.260753 8.1583 0.260753 7.8417 0.456023 7.6465L7.10247 1H2.80957C2.53343 1 2.30957 0.77614 2.30957 0.5C2.30957 0.22386 2.53343 0 2.80957 0H8.30957C8.44217 0 8.56937 0.05268 8.66317 0.14645C8.75687 0.24022 8.80957 0.36739 8.80957 0.5V6.00001C8.80957 6.27615 8.58567 6.5 8.30957 6.5C8.03347 6.5 7.80957 6.27615 7.80957 6.00001V1.70711L1.16312 8.3536C0.967863 8.5488 0.651283 8.5488 0.456023 8.3536Z",
    fill: "#64646B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUprightarr);
export default __webpack_public_path__ + "static/media/uprightarr.f66479253dd9485a4fecfe530c77db3e.svg";
export { ForwardRef as ReactComponent };